import React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function SelectComponent({
  label,
  onChange,
  data,
  val,
  disabled,
  filled,
}) {
  const handleChange = (event) => {
    const selectedId = event.target.value;
    const selectedObj = data.find((v) => v.id === selectedId);
    onChange(selectedObj);
  };

  return (
    <Box
      sx={{ minWidth: 120 }}
      style={{
        marginBottom: 8,
        flex: 1,
        backgroundColor: filled ? "rgba(255,255,255,0.7)" : "white",
        borderRadius: 5,
      }}
    >
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select value={val || ""} onChange={handleChange} disabled={disabled}>
          {data ? (
            data.map((e) => {
              return (
                <MenuItem key={e.id} value={e.id}>
                  {e.name}
                </MenuItem>
              );
            })
          ) : (
            <MenuItem>Cargando...</MenuItem>
          )}
        </Select>
      </FormControl>
    </Box>
  );
}
